/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufEmpty from '../../../google/protobuf/empty.pb';
import * as GoogleProtobufTimestamp from '../../../google/protobuf/timestamp.pb';
import * as fm from '@generated/fetch.pb';

export enum RubricStage {
    RUBRIC_STAGE_UNSPECIFIED = 'RUBRIC_STAGE_UNSPECIFIED',
    EMERGING = 'EMERGING',
    DEVELOPING = 'DEVELOPING',
    EXPANDING = 'EXPANDING',
}

export type GetStudentListRequest = {
    sessionId?: string;
};

export type SessionStudent = {
    id?: string;
    name?: string;
    activeSubscription?: boolean;
    nickname?: string;
    isTrial?: boolean;
};

export type GetStudentListResponse = {
    students?: SessionStudent[];
};

export type GetZoomJoiningLinkRequest = {
    sessionId?: string;
    email?: string;
    participantName?: string;
};

export type GetZoomJoiningLinkResponse = {
    link?: string;
    hostKey?: string;
};

export type GetTeacherListRequest = {
    email?: string;
};

export type Teacher = {
    id?: string;
    name?: string;
    email?: string;
};

export type TeacherList = {
    teachers?: Teacher[];
};

export type UpsertTeacherFeedbackStatusRequest = {
    sessionId?: string;
    teacherId?: string;
    status?: number;
    sessionStartTime?: GoogleProtobufTimestamp.Timestamp;
    updatedBy?: string;
};

export type GetTeacherFeedbackForStudentRequest = {
    studentId?: string;
    startTime?: string;
    endTime?: string;
};

export type TeacherFeedback = {
    courseId?: string;
    sessionId?: string;
    teacherId?: string;
    studentId?: string;
    attendance?: boolean;
    punctuality?: boolean;
    participation?: number;
    levelRecommendation?: number;
};

export type GetTeacherFeedbackForStudentResponse = {
    feedbacks?: TeacherFeedback[];
};

export type InitializeGoogleOauthResponse = {
    link?: string;
};

export type VerifyOauthRequest = {
    code?: string;
    authuser?: string;
    scope?: string;
};

export type Token = {
    accessToken?: string;
    refreshToken?: string;
    frontToken?: string;
};

export type VerifyOauthResponse = {
    token?: Token;
};

export type DependencyStatus = {
    name?: string;
    healthy?: boolean;
    lastSuccessAt?: string;
    lastError?: string;
    lastErrorAt?: string;
};

export type VersionResponse = {
    name?: string;
    env?: string;
    version?: string;
    builtAt?: string;
    startedAt?: string;
    uptime?: string;
    dependencies?: DependencyStatus[];
};

export type GetWeeklyFeedbackSummaryRequest = {
    id?: string;
};

export type GetWeeklyFeedbackSummaryResponse = {
    summary?: WeeklyFeedbackSummary;
};

export type CreateWeeklyFeedbackSummaryRequest = {
    summary?: WeeklyFeedbackSummary;
};

export type CreateWeeklyFeedbackSummaryResponse = {
    summary?: WeeklyFeedbackSummary;
};

export type UpdateWeeklyFeedbackSummaryRequest = {
    id?: string;
    summary?: WeeklyFeedbackSummary;
};

export type UpdateWeeklyFeedbackSummaryResponse = {
    summary?: WeeklyFeedbackSummary;
};

export type DeleteWeeklyFeedbackSummaryRequest = {
    id?: string;
};

export type DeleteWeeklyFeedbackSummaryResponse = {
    success?: boolean;
};

export type WeeklyFeedbackSummary = {
    id?: string;
    studentId?: string;
    weekStartDate?: string;
    weekEndDate?: string;
    summary?: string;
    positiveStandouts?: string;
    areasForImprovement?: string;
    comfortLevelSummary?: string;
    participationSummary?: string;
    rawAiOutput?: string;
    feedbackIds?: string;
    createdAt?: string;
    updatedAt?: string;
};

export type MonthlyLearningRecap = {
    id?: string;
    studentId?: string;
    month?: string;
    year?: number;
    topicName?: string;
    topicDescriptionEn?: string;
    topicDescriptionIdn?: string;
    learningObjectivesEn?: string;
    learningObjectivesIdn?: string;
    vocabularyEn?: string;
    vocabularyIdn?: string;
    grammarEn?: string;
    grammarIdn?: string;
    /** @deprecated This field has been deprecated. */
    teacherFeedback?: string;
    skillDescriptorSummary?: string;
    overallAssessment?: string;
    attendanceCount?: number;
    rawAiOutput?: string;
    feedbackIds?: string;
    teacherFeedbackIdn?: string;
    teacherFeedbackEn?: string;
    autoQcPass?: boolean;
    createdAt?: string;
    updatedAt?: string;
};

export type CreateMonthlyLearningRecapRequest = {
    recap?: MonthlyLearningRecap;
};

export type GetMonthlyLearningRecapsRequest = {
    year?: number;
    month?: number;
};

export type GetMonthlyLearningRecapRequest = {
    id?: string;
};

export type GetLatestMonthlyLearningRecapRequest = {
    studentId?: string;
    year?: number;
    month?: number;
};

export type UpdateMonthlyLearningRecapRequest = {
    id?: string;
    recap?: MonthlyLearningRecap;
};

export type DeleteMonthlyLearningRecapRequest = {
    id?: string;
    recap?: MonthlyLearningRecap;
};

export type MonthlyLearningRecapResponse = {
    recap?: MonthlyLearningRecap;
};

export type MonthlyLearningRecapsResponse = {
    recaps?: MonthlyLearningRecap[];
};

export type DeleteMonthlyLearningRecapResponse = {
    success?: boolean;
};

export type GarageLevel = {
    id?: string;
    label?: string;
    program?: string;
    sequence?: number;
};

export type LocalizedTextInput = {
    locale?: string;
    value?: string;
};

export type LocalizedText = {
    value?: string;
    locale?: string;
    isFallback?: boolean;
    translations?: Record<string, string>;
};

export type VersionVisibility = {
    versionId?: string;
    isDefault?: boolean;
};

export type RubricItem = {
    stage?: string;
    level?: GarageLevel;
    demonstration?: LocalizedText;
    descriptors?: LocalizedText;
    anchors?: LocalizedText;
    exampleTask?: LocalizedText;
    teacherGuidance?: LocalizedText;
};

export type LearningObjectiveSummary = {
    id?: string;
    code?: string;
    statement?: LocalizedText;
    competencyName?: LocalizedText;
    focusAreaName?: LocalizedText;
    microStrandName?: LocalizedText;
    position?: number;
    sequenceInLevel?: number;
    levelNotes?: LocalizedText;
    assignedLevels?: GarageLevel[];
    rubrics?: RubricItem[];
    competencyId?: string;
    focusAreaId?: string;
    microStrandId?: string;
};

export type ListLevelLearningObjectivesRequest = {
    levelIds?: string[];
    levelLabels?: string[];
    curriculumVersion?: string;
    locale?: string;
    disableFallback?: boolean;
    includeTranslations?: boolean;
    version?: string;
};

export type LevelLearningObjectives = {
    level?: GarageLevel;
    learningObjectives?: LearningObjectiveSummary[];
};

export type ListLevelLearningObjectivesResponse = {
    levels?: LevelLearningObjectives[];
};

export type ListLevelsRequest = {
    curriculumVersion?: string;
    locale?: string;
    version?: string;
};

export type ListLevelsResponse = {
    garageLevels?: GarageLevel[];
    page?: number;
    perPage?: number;
    totalItems?: number;
    totalPages?: number;
};

export type ListCurriculumOverviewRequest = {
    levelIds?: string[];
    levelLabels?: string[];
    curriculumVersion?: string;
    locale?: string;
    disableFallback?: boolean;
    includeTranslations?: boolean;
    version?: string;
};

export type ListCurriculumOverviewResponse = {
    learningObjectives?: LearningObjectiveSummary[];
};

export type GetMicroStrandProgressionRequest = {
    microStrandId?: string;
    curriculumVersion?: string;
    locale?: string;
    disableFallback?: boolean;
    includeTranslations?: boolean;
    version?: string;
};

export type GetMicroStrandProgressionResponse = {
    microStrandId?: string;
    microStrandName?: LocalizedText;
    learningObjectives?: LearningObjectiveSummary[];
};

export type GetLearningObjectiveRequest = {
    learningObjectiveId?: string;
    curriculumVersion?: string;
    locale?: string;
    disableFallback?: boolean;
    includeTranslations?: boolean;
    version?: string;
};

export type GetLearningObjectiveResponse = {
    learningObjective?: LearningObjectiveSummary;
    levels?: GarageLevel[];
};

export type ListLearningObjectivesRequest = {
    curriculumVersion?: string;
    ids?: string[];
    codes?: string[];
    locale?: string;
    disableFallback?: boolean;
    includeRubrics?: boolean;
    includeLevels?: boolean;
};

export type ListLearningObjectivesResponse = {
    result?: LearningObjectiveSummary[];
};

export type CoreCompetencyManage = {
    id?: string;
    code?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    versionVisibility?: VersionVisibility[];
    createdAt?: GoogleProtobufTimestamp.Timestamp;
    updatedAt?: GoogleProtobufTimestamp.Timestamp;
};

export type ListCoreCompetenciesRequest = {
    page?: number;
    pageSize?: number;
    version?: string;
    locale?: string;
    search?: string;
};

export type ListCoreCompetenciesResponse = {
    items?: CoreCompetencyManage[];
    page?: number;
    pageSize?: number;
    total?: string;
};

export type CreateCoreCompetencyRequest = {
    code?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    versionVisibility?: VersionVisibility[];
    curriculumVersion?: string;
};

export type UpdateCoreCompetencyRequest = {
    id?: string;
    code?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    versionVisibility?: VersionVisibility[];
    curriculumVersion?: string;
};

export type ArchiveCoreCompetencyRequest = {
    id?: string;
};

export type FocusAreaManage = {
    id?: string;
    competencyId?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    createdAt?: GoogleProtobufTimestamp.Timestamp;
    updatedAt?: GoogleProtobufTimestamp.Timestamp;
    code?: string;
};

export type ListFocusAreasRequest = {
    page?: number;
    pageSize?: number;
    version?: string;
    competencyId?: string;
    locale?: string;
    search?: string;
};

export type ListFocusAreasResponse = {
    items?: FocusAreaManage[];
    page?: number;
    pageSize?: number;
    total?: string;
};

export type CreateFocusAreaRequest = {
    competencyId?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    curriculumVersion?: string;
};

export type UpdateFocusAreaRequest = {
    id?: string;
    competencyId?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    curriculumVersion?: string;
};

export type ArchiveFocusAreaRequest = {
    id?: string;
};

export type MicroStrandManage = {
    id?: string;
    focusAreaId?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    createdAt?: GoogleProtobufTimestamp.Timestamp;
    updatedAt?: GoogleProtobufTimestamp.Timestamp;
    code?: string;
};

export type ListMicroStrandsRequest = {
    page?: number;
    pageSize?: number;
    version?: string;
    focusAreaId?: string;
    locale?: string;
    search?: string;
};

export type ListMicroStrandsResponse = {
    items?: MicroStrandManage[];
    page?: number;
    pageSize?: number;
    total?: string;
};

export type CreateMicroStrandRequest = {
    focusAreaId?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    curriculumVersion?: string;
};

export type UpdateMicroStrandRequest = {
    id?: string;
    focusAreaId?: string;
    names?: LocalizedTextInput[];
    descriptions?: LocalizedTextInput[];
    curriculumVersion?: string;
};

export type ArchiveMicroStrandRequest = {
    id?: string;
};

export type LevelAssignmentInput = {
    levelId?: string;
    notes?: string;
    sequenceOverride?: number;
};

export type LearningObjectiveManage = {
    id?: string;
    code?: string;
    competencyId?: string;
    focusAreaId?: string;
    microStrandId?: string;
    statements?: LocalizedTextInput[];
    rationales?: LocalizedTextInput[];
    proficiencyStage?: string;
    assignedLevels?: LevelAssignmentInput[];
    versionVisibility?: VersionVisibility[];
    notes?: string;
    createdAt?: GoogleProtobufTimestamp.Timestamp;
    updatedAt?: GoogleProtobufTimestamp.Timestamp;
};

export type ListLearningObjectivesManageRequest = {
    page?: number;
    pageSize?: number;
    version?: string;
    microStrandId?: string;
    levelLabels?: string[];
    locale?: string;
    search?: string;
};

export type ListLearningObjectivesManageResponse = {
    items?: LearningObjectiveManage[];
    page?: number;
    pageSize?: number;
    total?: string;
};

export type CreateLearningObjectiveManageRequest = {
    code?: string;
    competencyId?: string;
    focusAreaId?: string;
    microStrandId?: string;
    statements?: LocalizedTextInput[];
    rationales?: LocalizedTextInput[];
    proficiencyStage?: string;
    assignedLevels?: LevelAssignmentInput[];
    versionVisibility?: VersionVisibility[];
    notes?: string;
    curriculumVersion?: string;
};

export type UpdateLearningObjectiveManageRequest = {
    id?: string;
    code?: string;
    competencyId?: string;
    focusAreaId?: string;
    microStrandId?: string;
    statements?: LocalizedTextInput[];
    rationales?: LocalizedTextInput[];
    proficiencyStage?: string;
    assignedLevels?: LevelAssignmentInput[];
    versionVisibility?: VersionVisibility[];
    notes?: string;
    curriculumVersion?: string;
};

export type ArchiveLearningObjectiveManageRequest = {
    id?: string;
};

export type RubricEntryInput = {
    stage?: RubricStage;
    demonstration?: LocalizedTextInput[];
    descriptors?: LocalizedTextInput[];
    anchors?: LocalizedTextInput[];
    exampleTask?: LocalizedTextInput[];
    teacherGuidance?: LocalizedTextInput[];
};

export type CompetencyRubricManage = {
    id?: string;
    learningObjectiveId?: string;
    entries?: RubricEntryInput[];
    localeOverrides?: LocalizedTextInput[];
    createdAt?: GoogleProtobufTimestamp.Timestamp;
    updatedAt?: GoogleProtobufTimestamp.Timestamp;
};

export type ListCompetencyRubricsRequest = {
    page?: number;
    pageSize?: number;
    version?: string;
    learningObjectiveId?: string;
    locale?: string;
    search?: string;
};

export type ListCompetencyRubricsResponse = {
    items?: CompetencyRubricManage[];
    page?: number;
    pageSize?: number;
    total?: string;
};

export type CreateCompetencyRubricRequest = {
    learningObjectiveId?: string;
    entries?: RubricEntryInput[];
    localeOverrides?: LocalizedTextInput[];
    curriculumVersion?: string;
};

export type UpdateCompetencyRubricRequest = {
    id?: string;
    learningObjectiveId?: string;
    entries?: RubricEntryInput[];
    localeOverrides?: LocalizedTextInput[];
    curriculumVersion?: string;
};

export type ArchiveCompetencyRubricRequest = {
    id?: string;
};

export type CurriculumVersion = {
    id?: string;
    version?: string;
    name?: string;
    notes?: string;
    effectiveFrom?: GoogleProtobufTimestamp.Timestamp;
    effectiveTo?: GoogleProtobufTimestamp.Timestamp;
    createdAt?: GoogleProtobufTimestamp.Timestamp;
    updatedAt?: GoogleProtobufTimestamp.Timestamp;
};

export type ListCurriculumVersionsRequest = Record<string, never>;

export type ListCurriculumVersionsResponse = {
    items?: CurriculumVersion[];
};

export type CreateCurriculumVersionRequest = {
    version?: string;
    name?: string;
    notes?: string;
    effectiveFrom?: GoogleProtobufTimestamp.Timestamp;
    effectiveTo?: GoogleProtobufTimestamp.Timestamp;
};

export class Paula {
    static GetStudentList(
        this: void,
        req: GetStudentListRequest,
        initReq?: fm.InitReq
    ): Promise<GetStudentListResponse> {
        return fm.fetchRequest<GetStudentListResponse>(
            `/v1/session/${req.sessionId}/students?${fm.renderURLSearchParams(req, [
                'sessionId',
            ])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static Ping(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/ping?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static Version(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<VersionResponse> {
        return fm.fetchRequest<VersionResponse>(
            `/version?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetZoomJoiningLink(
        this: void,
        req: GetZoomJoiningLinkRequest,
        initReq?: fm.InitReq
    ): Promise<GetZoomJoiningLinkResponse> {
        return fm.fetchRequest<GetZoomJoiningLinkResponse>(
            `/v1/session/zoom_link?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetTeacherList(
        this: void,
        req: GetTeacherListRequest,
        initReq?: fm.InitReq
    ): Promise<TeacherList> {
        return fm.fetchRequest<TeacherList>(
            `/v1/teachers?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static UpsertTeacherFeedbackStatus(
        this: void,
        req: UpsertTeacherFeedbackStatusRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(`/feedback_status`, {
            ...initReq,
            method: 'POST',
            body: JSON.stringify(req, fm.replacer),
        });
    }
    static GetTeacherFeedbackForStudent(
        this: void,
        req: GetTeacherFeedbackForStudentRequest,
        initReq?: fm.InitReq
    ): Promise<GetTeacherFeedbackForStudentResponse> {
        return fm.fetchRequest<GetTeacherFeedbackForStudentResponse>(
            `/v1/feedback?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static InitializeGoogleOauth(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<InitializeGoogleOauthResponse> {
        return fm.fetchRequest<InitializeGoogleOauthResponse>(
            `/oauth/google?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static VerifyOauth(
        this: void,
        req: VerifyOauthRequest,
        initReq?: fm.InitReq
    ): Promise<VerifyOauthResponse> {
        return fm.fetchRequest<VerifyOauthResponse>(`/oauth/verify`, {
            ...initReq,
            method: 'POST',
            body: JSON.stringify(req, fm.replacer),
        });
    }
    static GetWeeklyFeedbackSummary(
        this: void,
        req: GetWeeklyFeedbackSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<GetWeeklyFeedbackSummaryResponse> {
        return fm.fetchRequest<GetWeeklyFeedbackSummaryResponse>(
            `/v1/weekly-feedback-summaries/${req.id}?${fm.renderURLSearchParams(
                req,
                ['id']
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateWeeklyFeedbackSummary(
        this: void,
        req: CreateWeeklyFeedbackSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<CreateWeeklyFeedbackSummaryResponse> {
        return fm.fetchRequest<CreateWeeklyFeedbackSummaryResponse>(
            `/v1/weekly-feedback-summaries`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static UpdateWeeklyFeedbackSummary(
        this: void,
        req: UpdateWeeklyFeedbackSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<UpdateWeeklyFeedbackSummaryResponse> {
        return fm.fetchRequest<UpdateWeeklyFeedbackSummaryResponse>(
            `/v1/weekly-feedback-summaries/${req.id}`,
            { ...initReq, method: 'PUT', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static DeleteWeeklyFeedbackSummary(
        this: void,
        req: DeleteWeeklyFeedbackSummaryRequest,
        initReq?: fm.InitReq
    ): Promise<DeleteWeeklyFeedbackSummaryResponse> {
        return fm.fetchRequest<DeleteWeeklyFeedbackSummaryResponse>(
            `/v1/weekly-feedback-summaries/${req.id}?${fm.renderURLSearchParams(
                req,
                ['id']
            )}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static CreateMonthlyLearningRecap(
        this: void,
        req: CreateMonthlyLearningRecapRequest,
        initReq?: fm.InitReq
    ): Promise<MonthlyLearningRecapResponse> {
        return fm.fetchRequest<MonthlyLearningRecapResponse>(
            `/v1/monthly-learning-recaps`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static GetMonthlyLearningRecaps(
        this: void,
        req: GetMonthlyLearningRecapsRequest,
        initReq?: fm.InitReq
    ): Promise<MonthlyLearningRecapsResponse> {
        return fm.fetchRequest<MonthlyLearningRecapsResponse>(
            `/v1/monthly-learning-recaps?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMonthlyLearningRecap(
        this: void,
        req: GetMonthlyLearningRecapRequest,
        initReq?: fm.InitReq
    ): Promise<MonthlyLearningRecapResponse> {
        return fm.fetchRequest<MonthlyLearningRecapResponse>(
            `/v1/monthly-learning-recaps/${req.id}?${fm.renderURLSearchParams(req, [
                'id',
            ])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetLatestMonthlyLearningRecap(
        this: void,
        req: GetLatestMonthlyLearningRecapRequest,
        initReq?: fm.InitReq
    ): Promise<MonthlyLearningRecapResponse> {
        return fm.fetchRequest<MonthlyLearningRecapResponse>(
            `/v1/monthly-learning-recaps/${req.studentId}/${req.year}/${
                req.month
            }/latest?${fm.renderURLSearchParams(req, [
                'studentId',
                'year',
                'month',
            ])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static UpdateMonthlyLearningRecap(
        this: void,
        req: UpdateMonthlyLearningRecapRequest,
        initReq?: fm.InitReq
    ): Promise<MonthlyLearningRecapResponse> {
        return fm.fetchRequest<MonthlyLearningRecapResponse>(
            `/v1/monthly-learning-recaps/${req.id}`,
            { ...initReq, method: 'PUT', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static DeleteMonthlyLearningRecap(
        this: void,
        req: DeleteMonthlyLearningRecapRequest,
        initReq?: fm.InitReq
    ): Promise<DeleteMonthlyLearningRecapResponse> {
        return fm.fetchRequest<DeleteMonthlyLearningRecapResponse>(
            `/v1/monthly-learning-recaps/${req.id}?${fm.renderURLSearchParams(req, [
                'id',
            ])}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static ListCurriculumOverview(
        this: void,
        req: ListCurriculumOverviewRequest,
        initReq?: fm.InitReq
    ): Promise<ListCurriculumOverviewResponse> {
        return fm.fetchRequest<ListCurriculumOverviewResponse>(
            `/v1/curriculum/overview?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static ListLevelLearningObjectives(
        this: void,
        req: ListLevelLearningObjectivesRequest,
        initReq?: fm.InitReq
    ): Promise<ListLevelLearningObjectivesResponse> {
        return fm.fetchRequest<ListLevelLearningObjectivesResponse>(
            `/v1/curriculum/levels/learning-objectives?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static ListLevels(
        this: void,
        req: ListLevelsRequest,
        initReq?: fm.InitReq
    ): Promise<ListLevelsResponse> {
        return fm.fetchRequest<ListLevelsResponse>(
            `/v1/curriculum/levels?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetMicroStrandProgression(
        this: void,
        req: GetMicroStrandProgressionRequest,
        initReq?: fm.InitReq
    ): Promise<GetMicroStrandProgressionResponse> {
        return fm.fetchRequest<GetMicroStrandProgressionResponse>(
            `/v1/curriculum/micro-strands/${
                req.microStrandId
            }/progression?${fm.renderURLSearchParams(req, ['microStrandId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetLearningObjective(
        this: void,
        req: GetLearningObjectiveRequest,
        initReq?: fm.InitReq
    ): Promise<GetLearningObjectiveResponse> {
        return fm.fetchRequest<GetLearningObjectiveResponse>(
            `/v1/curriculum/learning-objectives/${
                req.learningObjectiveId
            }?${fm.renderURLSearchParams(req, ['learningObjectiveId'])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static ListLearningObjectives(
        this: void,
        req: ListLearningObjectivesRequest,
        initReq?: fm.InitReq
    ): Promise<ListLearningObjectivesResponse> {
        return fm.fetchRequest<ListLearningObjectivesResponse>(
            `/v1/curriculum/learning-objectives?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static ListCoreCompetencies(
        this: void,
        req: ListCoreCompetenciesRequest,
        initReq?: fm.InitReq
    ): Promise<ListCoreCompetenciesResponse> {
        return fm.fetchRequest<ListCoreCompetenciesResponse>(
            `/v1/curriculum/manage/competencies?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateCoreCompetency(
        this: void,
        req: CreateCoreCompetencyRequest,
        initReq?: fm.InitReq
    ): Promise<CoreCompetencyManage> {
        return fm.fetchRequest<CoreCompetencyManage>(
            `/v1/curriculum/manage/competencies`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static UpdateCoreCompetency(
        this: void,
        req: UpdateCoreCompetencyRequest,
        initReq?: fm.InitReq
    ): Promise<CoreCompetencyManage> {
        return fm.fetchRequest<CoreCompetencyManage>(
            `/v1/curriculum/manage/competencies/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static ArchiveCoreCompetency(
        this: void,
        req: ArchiveCoreCompetencyRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/v1/curriculum/manage/competencies/${req.id}?${fm.renderURLSearchParams(
                req,
                ['id']
            )}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static ListFocusAreas(
        this: void,
        req: ListFocusAreasRequest,
        initReq?: fm.InitReq
    ): Promise<ListFocusAreasResponse> {
        return fm.fetchRequest<ListFocusAreasResponse>(
            `/v1/curriculum/manage/focus-areas?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateFocusArea(
        this: void,
        req: CreateFocusAreaRequest,
        initReq?: fm.InitReq
    ): Promise<FocusAreaManage> {
        return fm.fetchRequest<FocusAreaManage>(
            `/v1/curriculum/manage/focus-areas`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static UpdateFocusArea(
        this: void,
        req: UpdateFocusAreaRequest,
        initReq?: fm.InitReq
    ): Promise<FocusAreaManage> {
        return fm.fetchRequest<FocusAreaManage>(
            `/v1/curriculum/manage/focus-areas/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static ArchiveFocusArea(
        this: void,
        req: ArchiveFocusAreaRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/v1/curriculum/manage/focus-areas/${req.id}?${fm.renderURLSearchParams(
                req,
                ['id']
            )}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static ListMicroStrands(
        this: void,
        req: ListMicroStrandsRequest,
        initReq?: fm.InitReq
    ): Promise<ListMicroStrandsResponse> {
        return fm.fetchRequest<ListMicroStrandsResponse>(
            `/v1/curriculum/manage/micro-strands?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateMicroStrand(
        this: void,
        req: CreateMicroStrandRequest,
        initReq?: fm.InitReq
    ): Promise<MicroStrandManage> {
        return fm.fetchRequest<MicroStrandManage>(
            `/v1/curriculum/manage/micro-strands`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static UpdateMicroStrand(
        this: void,
        req: UpdateMicroStrandRequest,
        initReq?: fm.InitReq
    ): Promise<MicroStrandManage> {
        return fm.fetchRequest<MicroStrandManage>(
            `/v1/curriculum/manage/micro-strands/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static ArchiveMicroStrand(
        this: void,
        req: ArchiveMicroStrandRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/v1/curriculum/manage/micro-strands/${
                req.id
            }?${fm.renderURLSearchParams(req, ['id'])}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static ListLearningObjectivesManage(
        this: void,
        req: ListLearningObjectivesManageRequest,
        initReq?: fm.InitReq
    ): Promise<ListLearningObjectivesManageResponse> {
        return fm.fetchRequest<ListLearningObjectivesManageResponse>(
            `/v1/curriculum/manage/learning-objectives?${fm.renderURLSearchParams(
                req,
                []
            )}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateLearningObjectiveManage(
        this: void,
        req: CreateLearningObjectiveManageRequest,
        initReq?: fm.InitReq
    ): Promise<LearningObjectiveManage> {
        return fm.fetchRequest<LearningObjectiveManage>(
            `/v1/curriculum/manage/learning-objectives`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static UpdateLearningObjectiveManage(
        this: void,
        req: UpdateLearningObjectiveManageRequest,
        initReq?: fm.InitReq
    ): Promise<LearningObjectiveManage> {
        return fm.fetchRequest<LearningObjectiveManage>(
            `/v1/curriculum/manage/learning-objectives/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static ArchiveLearningObjectiveManage(
        this: void,
        req: ArchiveLearningObjectiveManageRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/v1/curriculum/manage/learning-objectives/${
                req.id
            }?${fm.renderURLSearchParams(req, ['id'])}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static ListCompetencyRubrics(
        this: void,
        req: ListCompetencyRubricsRequest,
        initReq?: fm.InitReq
    ): Promise<ListCompetencyRubricsResponse> {
        return fm.fetchRequest<ListCompetencyRubricsResponse>(
            `/v1/curriculum/manage/rubrics?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateCompetencyRubric(
        this: void,
        req: CreateCompetencyRubricRequest,
        initReq?: fm.InitReq
    ): Promise<CompetencyRubricManage> {
        return fm.fetchRequest<CompetencyRubricManage>(
            `/v1/curriculum/manage/rubrics`,
            { ...initReq, method: 'POST', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static UpdateCompetencyRubric(
        this: void,
        req: UpdateCompetencyRubricRequest,
        initReq?: fm.InitReq
    ): Promise<CompetencyRubricManage> {
        return fm.fetchRequest<CompetencyRubricManage>(
            `/v1/curriculum/manage/rubrics/${req.id}`,
            { ...initReq, method: 'PATCH', body: JSON.stringify(req, fm.replacer) }
        );
    }
    static ArchiveCompetencyRubric(
        this: void,
        req: ArchiveCompetencyRubricRequest,
        initReq?: fm.InitReq
    ): Promise<GoogleProtobufEmpty.Empty> {
        return fm.fetchRequest<GoogleProtobufEmpty.Empty>(
            `/v1/curriculum/manage/rubrics/${req.id}?${fm.renderURLSearchParams(
                req,
                ['id']
            )}`,
            { ...initReq, method: 'DELETE' }
        );
    }
    static ListCurriculumVersions(
        this: void,
        req: ListCurriculumVersionsRequest,
        initReq?: fm.InitReq
    ): Promise<ListCurriculumVersionsResponse> {
        return fm.fetchRequest<ListCurriculumVersionsResponse>(
            `/v1/curriculum/manage/versions?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static CreateCurriculumVersion(
        this: void,
        req: CreateCurriculumVersionRequest,
        initReq?: fm.InitReq
    ): Promise<CurriculumVersion> {
        return fm.fetchRequest<CurriculumVersion>(`/v1/curriculum/manage/versions`, {
            ...initReq,
            method: 'POST',
            body: JSON.stringify(req, fm.replacer),
        });
    }
}
